import { restApi } from '../../../services/api';
import { GetOrderProductIds } from '../orderBook.types';

const onlineOrderBookStoreRepository = () => {
  return {
    getOrderProductIds: (orderId: string) =>
      restApi.get<GetOrderProductIds>(`orders/${orderId}/order-products-ids`),
  };
};

export default onlineOrderBookStoreRepository;
